export default __webpack_public_path__ + "static/support-team-f0ea32f0ed5320fcfb800e4729571847.png";